import { WidgetT } from 'business/definitions';
import { createContext, useContext } from 'react';

type DashboardWidgetContextType = Pick<WidgetT, 'key'>;

export const DashboardWidgetContext = createContext<DashboardWidgetContextType>(
    {
        key: 0,
    },
);

export const useDashboardWidgetContext = () =>
    useContext(DashboardWidgetContext);
